import { render, staticRenderFns } from "./EnquiryModal.vue?vue&type=template&id=5b2f1945&scoped=true&"
import script from "./EnquiryModal.vue?vue&type=script&lang=js&"
export * from "./EnquiryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f1945",
  null
  
)

export default component.exports